// content/AIPosts/api.js
export async function fetchTopics() {
    const r = await fetch('/mlapi/posts/topics');
    if (!r.ok) throw new Error('Failed to load topics');
    return r.json();
  }
  
  export async function fetchList(topic, limit = 30) {
    const r = await fetch(`/mlapi/posts/list?topic=${encodeURIComponent(topic)}&limit=${limit}`);
    if (!r.ok) throw new Error('Failed to load list');
    return r.json();
  }
  
  export async function resolveKey(topic, date, slug) {
    const r = await fetch(`/mlapi/posts/resolve?topic=${encodeURIComponent(topic)}&date=${encodeURIComponent(date)}&slug=${encodeURIComponent(slug)}`);
    if (!r.ok) throw new Error('Not found');
    return r.json();
  }
  
  export async function fetchContentByKey(key) {
    const r = await fetch(`/mlapi/posts/content?key=${encodeURIComponent(key)}`);
    if (!r.ok) throw new Error('Failed to load content');
    return r.json();
  }
  
  export async function subscribeAll(email) {
    const r = await fetch('/mlapi/posts/subscribe', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ email, all: true })
    });
    if (!r.ok) throw new Error('Subscribe failed');
    return r.json();
  }
  
  export async function subscribeTopic(email, topic) {
    const r = await fetch('/mlapi/posts/subscribe', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ email, topics: [topic] })
    });
    if (!r.ok) throw new Error('Subscribe failed');
    return r.json();
  }
  
  export async function fetchSummaries(topic, limit = 30) {
    const r = await fetch(`/mlapi/posts/summaries?topic=${encodeURIComponent(topic)}&limit=${limit}`);
    if (!r.ok) throw new Error('Failed to load post summaries');
    return r.json();
  }
